import React from 'react'
import { RawHtmlInterface } from 'common/types/entities/RawHtmlInterface'
import { useDeviceModeContext } from '../../../../../../context/DeviceModeContext'
import { Button } from '../components'
import { useUpdateProp } from '../hooks/useUpdateProps'
import DeviceAppearanceNew from '../options/DeviceAppearance/DeviceAppearanceNew'
import HtmlAttrId from '../options/HtmlAttrId'
import TextAlignStyle from '../styles/TextAlignStyle'
import { SizeAndPositionGroup } from 'src/editor/shared/settings/groups/size-and-position'
import { useAceEditor } from 'src/editor/shared/hooks/use-ace-editor'

function NewRawHtmlSettings({ entity }: { entity: RawHtmlInterface }) {
  const updateProp = useUpdateProp(entity)
  const { isMobile } = useDeviceModeContext()

  const { AceEditor, onOpenCodeEditor } = useAceEditor()

  return (
    <React.Fragment>
      <TextAlignStyle
        textAlign={entity.textAlign}
        mobileTextAlign={entity.mobileTextAlign || entity.textAlign}
        update={updateProp('textAlign')}
        mobileUpdate={updateProp('mobileTextAlign')}
      />
      <Button
        small
        onClick={onOpenCodeEditor}
        helpMessage="entity_settings.raw_html.description"
      >
        entity_settings.raw_html.edit_label
      </Button>
      {AceEditor && (
        <AceEditor
          label="entity_settings.raw_html.label"
          value={entity.html}
          handleChange={updateProp('html')}
        />
      )}
      <SizeAndPositionGroup
        margin={isMobile ? entity.mobileMargin : entity.margin}
        updateMargin={updateProp(isMobile ? 'mobileMargin' : 'margin')}
      />
      <DeviceAppearanceNew entity={entity} />
      <HtmlAttrId attrId={entity.htmlAttrId} />
    </React.Fragment>
  )
}

export default NewRawHtmlSettings
